import {
  useAvailableExtensions,
  useWalletObserver,
} from "@sundaeswap/wallet-lite";
import { FC, useState } from "react";

import { WalletConnectDialog } from "./WalletConnectDialog";

interface ConnectWalletButtonProps {
  className?: string;
}

export const ConnectWalletButton: FC<ConnectWalletButtonProps> = ({
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const extensions = useAvailableExtensions();
  const { isPending } = useWalletObserver();

  return (
    <>
      <button
        className={`sr-btn-primary !w-auto !px-4 !py-2 !text-sm !font-medium ${className ?? ""}`}
        disabled={isPending || extensions.length === 0}
        onClick={() => setIsOpen(true)}
      >
        {isPending ? "Connecting..." : "Connect Wallet"}
      </button>
      <WalletConnectDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default ConnectWalletButton;
